import FilterChip from 'LuxKit/Chips/FilterChip'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import type {
  CruisePriceFilterProps,
} from 'components/Cruises/SearchPage/Filters/Inputs/Common/CruiseSearchExtraFilter/CruisePriceFilter'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { Form } from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchChips'
import ModalContext from 'contexts/ModalContext'
import ModalCruiseSearchPriceChip
  from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/Modal/ModalCruiseSearchPriceChip'

export interface CruiseSearchPriceChipProps {
  facets: App.CruiseSearchFacetsV2
  filters: {
    price: {
      min?: number
      max?: number
    }
  }
  listFilters: CruisePriceFilterProps
  filterForm: Form
  setFilterForm: (form: Form) => void
  fetching?: boolean
  drawerMode?: boolean
}

function CruiseSearchPriceChip(props: CruiseSearchPriceChipProps) {
  const {
    filters,
    listFilters,
    facets,
    filterForm,
    setFilterForm,
    fetching,
    drawerMode,
  } = props
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const selected = useMemo(() => {
    const cruisePrices = facets.cruisePrices
    if (!cruisePrices) return false
    const minPrice = !!filters.price?.min && filters.price.min > cruisePrices.min
    const maxPrice = !!filters.price?.max && filters.price.max < cruisePrices.max
    return minPrice || maxPrice
  }, [facets.cruisePrices, filters.price?.max, filters.price?.min])

  const openModal = useCallback(async() => {
    await showModal(
      <ModalCruiseSearchPriceChip
        drawerMode={drawerMode}
        listFilters={listFilters}
        facets={facets}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        fetching={fetching}
        filters={filters}
      />,
    )
  }, [drawerMode, facets, fetching, filterForm, filters, listFilters, setFilterForm, showModal])

  const chipLabel = intl.formatMessage({
    id: 'NONcxGxlIdc-9lYlj0ge',
    defaultMessage: 'Price',
    description: 'Filter chip label for cruise price filter in the cruise section',
  })

  return <FilterChip
    data-testid="cruise-search-price-chip-button"
    selected={selected}
    size="medium"
    onClick={openModal}
    endIcon={<LineAngleDownIcon />}
  >
    {chipLabel}
  </FilterChip>
}

export default CruiseSearchPriceChip
